// removed by extract-text-webpack-plugin
module.exports = {"root":"_1tGnBvO"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/Accessibility/ScreenReaderSkipTarget.less
 ** module id = 898
 ** module chunks = 0
 **/